import styles from "./label.module.less";

const Label = (props) => {
  return (
    <div className={styles.labelWrapper}>
      <span className={[styles.label, "p_small"].join(" ")}>{props.title}</span>
    </div>
  );
};

export default Label;
